<div class="result-header-container container">
  <div class="rectangle-header-result">
      <div class="header-pagination">
      <span id="resultKeyWord" class="text-search">{{ title }}</span>
      <app-search-header-item-amount [itemCount]="itemCount" class="amount-text"></app-search-header-item-amount>
    </div>
  </div>
</div>